import { TableColumnsType, Tooltip } from "antd";
import { formatDateTime } from "../../../utils";

export type UploadHistoryTableColumnsTypes = {
  key: React.Key;
  fileName: React.ReactNode;
  clientName: React.ReactNode;
  uploadDate: React.Key;
  status: React.ReactNode;
  summary: React.ReactNode;
};

type BankDetails = {
  bankName: string;
  accountNumber: string;
  bankHolderName: string;
  ifsc: string;
  branchName: string;
  branchAddress: string;
};

export type LenderListTableColumnsTypes = {
  clientId: React.Key;
  clientName: string;
  companyName: string;
  mobileNumber: string;
  email: string;
  address: string;
  createDate: string;
  updateDate: string;
  bankDetails: BankDetails | null;
};

export const UploadHistoryColumn: TableColumnsType<UploadHistoryTableColumnsTypes> = [
  {
    title: "File Name",
    dataIndex: "fileName",
    render: (name: string) => <span>{name || "-"}</span>,
  },
  {
    title: "Lender Name",
    dataIndex: "clientName",
    render: (name: string) => <span>{name || "-"}</span>,
  },
  {
    title: "Upload Date & Time",
    dataIndex: "uploadDate",
    render: (name: string) => <span>{formatDateTime(name) || "-"}</span>,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (name: string) => <span>{name || "-"}</span>,
  },
  {
    title: "Summary",
    dataIndex: "summary",
    render: (name) => {
      if (!name) {
        return <span>-</span>;
      } else {
        return (
          <Tooltip title={"Please check mail for further details"}>
            <span className="flex">{name || "-"}</span>
          </Tooltip>
        );
      }
    },
  },
];

export const LenderListColumn: TableColumnsType<LenderListTableColumnsTypes> = [
  {
    title: "Lender ID",
    dataIndex: "clientId",
    render: (clientId: string) => <span>{clientId || "-"}</span>,
  },
  {
    title: "Name",
    dataIndex: "clientName",
    render: (clientName: string) => <span>{clientName || "-"}</span>,
  },
  {
    title: "Company",
    dataIndex: "companyName",
    render: (companyName: string) => <span>{companyName || "-"}</span>,
  },
  {
    title: "Phone",
    dataIndex: "mobileNumber",
    render: (mobileNumber: string) => <span>{mobileNumber || "-"}</span>,
  },
  // {
  //   title: "Email",
  //   dataIndex: "email",
  //   width: 50,
  //   render: (email: string) => <span>{email || "-"}</span>,
  // },
  // {
  //   title: "Address",
  //   dataIndex: "address",
  //   render: (address: string) => <span>{address || "-"}</span>,
  // },
  {
    title: "Created on",
    dataIndex: "createDate",
    render: (createDate: string) => <span>{createDate || "-"}</span>,
  },
  {
    title: "Last Updated",
    dataIndex: "updateDate",
    render: (updateDate: string) => <span>{updateDate || "-"}</span>,
  },
  // {
  //   title: "Bank Name",
  //   dataIndex: "bankDetails",
  //   // width: 200,
  //   render: (_: any, record: LenderListTableColumnsTypes) => {
  //     const bank = record.bankDetails as any;
  //     if (!bank || typeof bank !== "object") return "-";

  //     return (
  //       <div>
  //         <div>{bank.bankName || "-"}</div>
  //       </div>
  //     );
  //   },
  // },
  {
    title: "Details",
    dataIndex: "edit",
    key: "edit",
  },
];
